// extracted by mini-css-extract-plugin
export default {"text-gray":"ChipsInput_text-gray__jHziG"};